import { render } from "./SectionNavigationHeader.vue?vue&type=template&id=559daec0"
import script from "./SectionNavigationHeader.vue?vue&type=script&lang=js"
export * from "./SectionNavigationHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__